import { render, staticRenderFns } from "./snippletTabella.vue?vue&type=template&id=0355f2a4&scoped=true"
import script from "./snippletTabella.vue?vue&type=script&lang=js"
export * from "./snippletTabella.vue?vue&type=script&lang=js"
import style0 from "./snippletTabella.vue?vue&type=style&index=0&id=0355f2a4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0355f2a4",
  null
  
)

export default component.exports